export function getLabel(correlations, correlation) {
    const label = Object.keys(correlation.attachment)
        .map((otherAtomType) => correlation.attachment[otherAtomType]
        .map((index) => {
        var _a;
        return ((_a = correlations[index]) === null || _a === void 0 ? void 0 : _a.label)
            ? correlation.label[correlations[index].label.origin]
            : '';
    })
        .filter((_label) => _label && _label.length > 0))
        .flat()
        .filter((_label, i, a) => a.indexOf(_label) === i)
        .sort((a, b) => Number(a.split(/[a-z]+/i)[1]) - Number(b.split(/[a-z]+/i)[1]) < 0
        ? -1
        : Number(a.split(/[a-z]+/i)[1]) - Number(b.split(/[a-z]+/i)[1]) === 0 &&
            a.split(/\d+/)[1] < b.split(/\d+/)[1]
            ? -1
            : 1)
        .join('/');
    if (label.length > 0) {
        return label;
    }
    return correlation.label.origin;
}
//# sourceMappingURL=getLabel.js.map